import { Heading } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { HeadingProps } from '../../typography';

export function ModalHeading(props: HeadingProps): ReactNode {
  return (
    <Heading
      as="h1"
      fontSize="18px"
      lineHeight="32px"
      fontWeight="500"
      {...props}
    />
  );
}
